const allData = [
  {
    campus: 'UC Berkeley',
    origin: 'California',
    'Number of human remains and cultural objects': 121159,
  },
  {
    campus: 'UC Berkeley',
    origin: 'All other origins',
    'Number of human remains and cultural objects': 1882,
  },
  {
    campus: 'UCLA',
    origin: 'California',
    'Number of human remains and cultural objects': 1,
  },
  {
    campus: 'UCLA',
    origin: 'All other origins',
    'Number of human remains and cultural objects': 0,
  },
  {
    campus: 'UC Davis',
    origin: 'California',
    'Number of human remains and cultural objects': 3644,
  },
  {
    campus: 'UC Davis',
    origin: 'All other origins',
    'Number of human remains and cultural objects': 71,
  },
  {
    campus: 'UC Santa Barbara',
    origin: 'California',
    'Number of human remains and cultural objects': 5,
  },
  {
    campus: 'UC Santa Barbara',
    origin: 'All other origins',
    'Number of human remains and cultural objects': 4,
  },
  {
    campus: 'UC Riverside',
    origin: 'California',
    'Number of human remains and cultural objects': 0,
  },
  {
    campus: 'UC Riverside',
    origin: 'All other origins',
    'Number of human remains and cultural objects': 5,
  },
];

export default allData;
